<template>
  <BoardView :pagination="pagination" :title="$t('title')" :total="total">
    <Route
      v-if="hasRole('>=MANAGER')"
      slot="button"
      class="Btn withIcon icon-side-left info"
      to="PromptsAdd">
      <Icon name="plus" /> {{ $t('button') }}
    </Route>
    <BoardTable
      :hasResults="!!total"
      :isFetching="isFetching"
      :pagination="pagination">
      <Row>
        <Column v-for="prompt in results" :key="prompt.id" :xl="6">
          <RecordPrompt :prompt="prompt" />
        </Column>
      </Row>
    </BoardTable>
    <router-view />
  </BoardView>
</template>

<script>
import RecordPrompt from './components/RecordPrompt'
import Table from '@mixins/Table'

export default {
  mixins: [Table],
  components: { RecordPrompt },
  data() {
    return {
      paginationOptions: {
        name: 'prompt',
        service: 'prompt',
      },
    }
  },
}
</script>

<style lang="scss">
</style>

<i18n>
{
  "en": {
    "title": "Prompts",
    "button": "Add a prompt"
  }
}
</i18n>
